import React, { useState } from "react";

export default function QuestionReportsModal({ reports, onClose }) {
  const [activeDescription, setActiveDescription] = useState(null);

  return (
    <div style={styles.backdrop}>
      <div style={styles.modal}>
        <h3 style={styles.title}>Soru Raporları</h3>

        {/* Table Header */}
        <div style={styles.headerRow}>
          <div style={{ flex: 1, fontWeight: "bold" }}>Konu</div>
          <div style={{ flex: 2, fontWeight: "bold" }}>Mesaj</div>
        </div>

        {/* Table Rows */}
        {reports.map(function (report, i) {
          const issues = report.Issiues || {};
          const name = issues.Name || "";
          const description = issues.Description || "";
          const message = report.Message || "";

          return (
            <div key={i} style={styles.row}>
              <div style={styles.nameCell}>
              <span
                  style={styles.infoIcon}
                  onMouseEnter={function () {
                    setActiveDescription(description);
                  }}
                  onMouseLeave={function () {
                    setActiveDescription(null);
                  }}
                  onClick={function () {
                    setActiveDescription(
                      activeDescription === description ? null : description
                    );
                  }}
                >
                  !
                </span>
                <span>{name}</span>
                

                {/* Tooltip / Description bubble */}
                {activeDescription === description && (
                  <div style={styles.tooltip}>
                    {description || "Açıklama bulunamadı."}
                  </div>
                )}
              </div>
              <div style={styles.messageCell}>{message ? message : "-"}</div>
            </div>
          );
        })}

        <div style={styles.footer}>
          <button onClick={onClose} style={styles.closeBtn}>
            Kapat
          </button>
        </div>
      </div>
    </div>
  );
}

var styles = {
  backdrop: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0,0,0,0.4)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
  },
  modal: {
    background: "white",
    borderRadius: 12,
    padding: "24px",
    width: "480px",
    maxHeight: "80vh",
    overflowY: "auto",
    position: "relative",
    fontFamily: "sans-serif",
  },
  title: {
    textAlign: "center",
    marginBottom: "16px",
    fontSize: "20px",
    fontWeight: "600",
  },
  headerRow: {
    display: "flex",
    justifyContent: "space-between",
    borderBottom: "2px solid #eee",
    paddingBottom: "8px",
    marginBottom: "6px",
  },
  row: {
    display: "flex",
    alignItems: "flex-start",
    padding: "8px 0",
    borderBottom: "1px solid #f2f2f2",
    position: "relative",
  },
  nameCell: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    gap: "8px",
    position: "relative",
  },
  messageCell: {
    flex: 2,
    color: "#333",
    fontSize: "14px",
  },
  infoIcon: {
    backgroundColor: "#F87171",
    color: "white",
    borderRadius: "50%",
    width: "18px",
    height: "18px",
    fontSize: "12px",
    textAlign: "center",
    lineHeight: "18px",
    cursor: "pointer",
    fontWeight: "bold",
    position: "relative",
  },
  tooltip: {
    position: "absolute",
    top: "120%",
    left: "0",
    backgroundColor: "#fee2e2",
    color: "#7f1d1d",
    padding: "10px",
    borderRadius: "8px",
    width: "220px",
    fontSize: "13px",
    boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
    zIndex: 100,
  },
  footer: {
    display: "flex",
    justifyContent: "center",
    marginTop: "20px",
  },
  closeBtn: {
    padding: "8px 16px",
    borderRadius: "6px",
    backgroundColor: "#2563eb",
    color: "white",
    border: "none",
    cursor: "pointer",
    fontWeight: "bold",
  },
};
